import { render } from "./RankBoard.vue?vue&type=template&id=62e5a010"
import script from "./RankBoard.vue?vue&type=script&lang=js"
export * from "./RankBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__